<template>
  <el-drawer
    size="900px"
    :visible.sync="drawerShow"
    :wrapper-closable="false"
    :append-to-body="true"
    custom-class="em-order-detail"
    :before-close="closeDrawer"
  >
    <div slot="title" class="flex justify-content-space-between align-items-center">
      <span style="font-size: 16px;color: rgba(48, 49, 51, 1);">{{ order_detail.order_sn }}</span>
      <span>
        <el-button type="danger" plain size="mini" class="mr-sm" @click="deleteOrder">删除</el-button>
      </span>
    </div>
    <div class="pl-lg mb-sm">
      <div class="mb"><span class="front-line">订单信息</span></div>
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="flex align-items-center content" style="width: 100%;">
            <div class="form-title text-muted">订单主题：</div>
            <div v-if="order_detail.subject_editing" class="flex align-items-center">
              <el-input ref="subjectInput" v-model="order_detail.subject" style="width: 355px;" @blur="saveOrder('subject')" />
            </div>
            <div v-else class="subject-content flex align-items-center">
              <span v-overflow-tooltip="1" class="content ellipsis">{{ order_detail.subject }}</span>
              <i v-if="!editing" class="el-icon-edit-outline text-muted hover-show ml-sm" style="cursor: pointer;" @click="editOrder('subject')"></i>
            </div>
          </div>
          <div class="mt mb flex align-items-center">
            <div class="form-title text-muted pr hd">用户：</div>
            <f-user-avatar :src="order_detail.buyer_avatar" shape="rounded" class="hd avatar mr-sm" />
            <f-user-name :user="{ nickname: order_detail.buyer_nickname, memberid: order_detail.memberid }"
              class="content bd ellipsis" style="max-width: 300px;" />
          </div>
          <div class="mt mb flex align-items-center">
            <div class="form-title text-muted">支付状态：</div>
            <span class="content">
              <el-tag v-if="order_detail.pay_status === 0" type="danger">待支付</el-tag>
              <el-tag v-else-if="order_detail.pay_status === 1" type="success">已支付</el-tag>
              <el-button v-if="order_detail.pay_status === 0" type="primary" size="mini" class="ml-sm"
                @click="confirmPayment">确认支付</el-button>
            </span>
          </div>
          <div class="mt mb flex align-items-center">
            <div class="form-title text-muted">发货状态：</div>
            <span class="content">
              <el-tag v-if="order_detail.shipping_status === 0" type="danger">待发货</el-tag>
              <el-tag v-else-if="order_detail.shipping_status === 1" type="warning">已发货</el-tag>
              <el-tag v-else-if="order_detail.shipping_status === 3" type="success">已签收</el-tag>
              <el-button v-if="order_detail.shipping_status === 0" type="primary" size="mini" class="ml-sm"
                @click="confirmShipping(order_detail.shipping_status)">确认发货</el-button>
              <el-button v-if="order_detail.shipping_status === 1" type="primary" size="mini" class="ml-sm"
                @click="confirmShipping(order_detail.shipping_status)">确认签收</el-button>
            </span>
          </div>
          <div class="mt mb flex align-items-center">
            <div class="form-title text-muted" style="line-height: 40px;">备注：</div>
            <div class="content flex1">
              <div v-if="order_detail.remark_editing">
                <el-input ref="remarkInput" v-model="order_detail.remark" style="width: 100%;" @blur="saveOrder('remark')" />
              </div>
              <div v-else class="remark-content flex align-items-center flex1">
                <span v-overflow-tooltip="1" class="content ellipsis" style="width: fit-content;">{{ order_detail.remark }}</span>
                <i v-if="!editing" class="el-icon-edit-outline text-muted ml-sm" style="cursor: pointer;" @click="editOrder('remark')"></i>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div>
            <span class="text-muted">创建时间：</span>
            <span class="content">{{ order_detail.createtime | parseTime('{y}/{m}/{d} {h}:{i}') }}</span>
          </div>
          <div class="mt mb">
            <span class="text-muted">支付方式：</span>
            <span class="content">{{ payTypeObj[order_detail.pay_type] }}</span>
          </div>
          <div class="mt mb">
            <span class="text-muted">支付时间：</span>
            <span class="content">{{ order_detail.pay_time | parseTime('{y}/{m}/{d} {h}:{i}') }}</span>
          </div>
          <div>
            <span class="text-muted">成交时间：</span>
            <span class="content">{{ order_detail.sign_time | parseTime('{y}/{m}/{d} {h}:{i}') }}</span>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 减去订单信息的高度 -->
    <div class="pl-lg pr-lg" style="height: calc(100% - 319px);">
      <div class="flex align-items-center mb">
        <span class="front-line mr-sm">订单明细</span>
      </div>
      <!-- 减去订单明细的头部和底部的高度 -->
      <el-table ref="listTable" :data="order_detail_items" height="calc(100% - 34px - 67px)" tooltip-effect="dark" class="padding-mini">
        <el-table-column width="50" type="index" label="#" />
        <el-table-column min-width="60" align="right">
          <template slot-scope="scope">
            <f-user-avatar :src="scope.row.item_thumb" shape="rounded" />
          </template>
        </el-table-column>
        <el-table-column prop="item_title" min-width="240" label="明细" show-overflow-tooltip />
        <el-table-column min-width="100" label="数量">
          <template slot-scope="scope">
            <template v-if="scope.row.num_editing">
              <el-input-number
                :id="'input_num_' + scope.row.orderitemid"
                v-model="scope.row.num"
                :disabled="!scope.row.num_editing"
                :step="1"
                :min="1"
                :controls="false"
                class="number"
                @blur="saveOrderItem(scope.row, 'num')"
              />
            </template>
            <div v-else>
              <span class="mr-sm">{{ scope.row.num }}</span>
              <i v-if="!editing" class="el-icon-edit-outline text-muted hover-show" style="cursor: pointer;"
                @click="editOrder('num', scope.row)"></i>
            </div>
          </template>
        </el-table-column>
        <el-table-column min-width="120" label="面价" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.market_price | currency }}</span>
          </template>
        </el-table-column>
        <el-table-column min-width="120" label="单价" show-overflow-tooltip>
          <template slot-scope="scope">
            <template v-if="scope.row.selling_price_editing">
              <el-input-number
                :id="'input_selling_price_' + scope.row.orderitemid"
                v-model="scope.row.selling_price"
                :disabled="!scope.row.selling_price_editing"
                :step="0.01"
                :min="0"
                :precision="2"
                :controls="false"
                @blur="saveOrderItem(scope.row, 'selling_price')"
              />
            </template>
            <div v-else>
              <span class="mr-sm">{{ scope.row.selling_price | currency }}</span>
              <i v-if="!editing" class="el-icon-edit-outline text-muted hover-show" style="cursor: pointer;"
                @click="editOrder('selling_price', scope.row)"></i>
            </div>
          </template>
        </el-table-column>

        <el-table-column min-width="120" label="金额小计" show-overflow-tooltip align="right">
          <template slot-scope="scope">
            <span>{{ scope.row.num * scope.row.selling_price | currency }}</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="flex align-items-center justify-content-flex-end mt">
        <p class="pb" style="margin: 0;">
          <span class="pr" style="color: #606266;">金额总计：</span>
          <span class="text-warning font-2x">{{ totalPrice | currency }}</span>
        </p>
      </div>
    </div>
  </el-drawer>
</template>

<script>
import {
  getGodProductOrderDetailApi,
  deleteGodProductOrderApi,
  saveGodProductOrderApi,
  saveGodProductOrderItemApi,
  postGodPayOrderApi,
  postGodShippingOrderApi
} from '@/api/ei/eiMallApi'
export default {
  name: 'OrderDetailPopover',

  mixins: [],

  props: {
    show: {
      type: Boolean,
      default: false
    },
    orderid: {
      type: Number,
      default: undefined
    }
  },
  data() {
    return {
      tableKey: 0,
      order_detail: {},
      order_detail_items: [],
      editing: false,
      payTypeObj: {
        1: '现款现货',
        2: '货到付款',
        3: '月结货款',
      },
      inputRefs: {
        num: {},
        selling_price: {}
      }
    };
  },

  watch: {
    show(val) {
      if (val) {
        this.fetchOrderDetail()
      }
    }
  },

  computed: {
    drawerShow: {
      get() {
        return this.show
      },
      set(val) {
        this.$emit('update:show', val)
      }
    },
    totalPrice() {
      return this.order_detail_items.reduce((acc, item) => {
        return acc + item.num * item.selling_price
      }, 0)
    },
  },
  methods: {
    closeDrawer() {
      this.drawerShow = false
      this.$emit('close')
    },
    fetchOrderDetail() {
      getGodProductOrderDetailApi({ orderid: this.orderid }).then(res => {
        if (!res.errno) {
          this.order_detail = {
            ...res.data,
            subject_editing: false,
            remark_editing: false,
          }
          this.order_detail_items = res.data.order_items.map(item => {
            return {
              ...item,
              num_editing: false,
              selling_price_editing: false,
            }
          })
        }
      })
    },
    deleteOrder() {
      this.$confirm('确定删除该订单吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '处理中...',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        deleteGodProductOrderApi({ orderid: this.orderid }).then(res => {
          loading.close()
          if (!res.errno) {
            this.closeDrawer()
            this.$message.success('删除成功')
            this.fetchData()
          } else {
            this.$message.error(res.message)
          }
        })
      })
    },
    saveOrder(type) {
      this.editing = false
      const temp = {
        orderid: this.orderid
      }
      if (type === 'subject') {
        this.order_detail.subject_editing = false
        temp.subject = this.order_detail.subject
      } else if (type === 'remark') {
        this.order_detail.remark_editing = false
        temp.remark = this.order_detail.remark
      }

      const loading = this.$loading({
        lock: true,
        text: '保存中...',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      saveGodProductOrderApi(temp).then(res => {
        loading.close()
        if (!res.errno) {
          this.$message.success('保存成功')
          this.fetchOrderDetail()
        } else {
          loading.close()
          this.$message.error(res.message)
        }
      })
    },
    saveOrderItem(row, type) {
      row[`${type}_editing`] = false
      this.editing = false
      const temp = {
        orderitemid: row.orderitemid
      }
      switch (type) {
        case 'num':
          temp.num = row.num
          break
        case 'selling_price':
          temp.selling_price = row.selling_price
          break
      }
      const loading = this.$loading({
        lock: true,
        text: '保存中...',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      saveGodProductOrderItemApi(temp).then(res => {
        loading.close()
        if (!res.errno) {
          this.$message.success('保存成功')
          this.fetchOrderDetail()
        } else {
          loading.close()
          this.$message.error(res.message)
        }
      })
    },
    confirmPayment() {
      this.$confirm('将订单的支付状态改为已支付，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        appendToBody: true
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '处理中...',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        postGodPayOrderApi({
          orderid: this.orderid,
        }).then(res => {
          loading.close()
          if (!res.errno) {
            this.$message.success('操作成功！')
            this.fetchOrderDetail()
          } else {
            loading.close()
            this.$message.error(res.message)
          }
        })
      })
    },
    confirmShipping(status) {
      const statusText = status === 0 ? '待发货' : '已发货'
      const statusText2 = status === 0 ? '已发货' : '已签收'
      const shipping_status = status === 0 ? 1 : 3
      this.$confirm(`将订单的${statusText}状态改为${statusText2}，是否继续？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '处理中...',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        postGodShippingOrderApi({
          orderid: this.orderid,
          shipping_status,
        }).then(res => {
          loading.close()
          if (!res.errno) {
            this.$message.success('操作成功！')
            this.fetchOrderDetail()
          } else {
            loading.close()
            this.$message.error(res.message)
          }
        })
      })
    },
    editOrder(type, row) {
      this.editing = true
      if (row) {
        row[`${type}_editing`] = true
        const inputId = `input_${type}_${row.orderitemid}`

        this.$nextTick(() => {
          const input = document.getElementById(inputId).querySelector('.el-input__inner')
          if (input) {
            input.focus()
          }
        })
      } else {
        if (type === 'subject') {
          this.order_detail.subject_editing = true
          this.$nextTick(() => {
            this.$refs.subjectInput && this.$refs.subjectInput.focus()
          })
        }
        if (type === 'remark') {
          this.order_detail.remark_editing = true
          this.$nextTick(() => {
            this.$refs.remarkInput && this.$refs.remarkInput.focus()
          })
        }
      }
    },
  }
};
</script>

<style lang="scss">
.em-order-detail {

  .el-drawer__header {
    margin-bottom: 0;
    padding-bottom: 20px;
  }

  .el-drawer__body {
    overflow: hidden;
  }

  .el-scrollbar__bar.is-vertical {
    display: none;
  }

  .content {
    height: 40px;
    line-height: 40px;
  }

  .form-title {
    width: 70px;
  }

  .subject-content {
    width: 355px;

    & > span {
      max-width: 335px;
      width: fit-content;
    }

    i {
      display: none;
    }

    &:hover {
      i {
        display: block;
      }
    }
  }

  .el-input-number {
    width: 85px;

    &.number {
      width: 65px;
    }
  }

  .remark-content {
    max-width: 355px;
    i {
      display: none;
    }

    &:hover {
      i {
        display: block;
      }
    }
  }
}
</style>
